import R from 'ramda';
import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import { getMemberByUserId } from '../../utils';
import PhotoContainer from '../PhotoContainer';
import { PublishesID } from '../../constants';

class DealChangeLog extends Component {
  getSummary(dealChange) {
    const changes = JSON.parse(dealChange.changes);

    if (changes && changes.contract_block) {
      if (changes.contract_block.id === 0) {
        return `Redistributed <strong>ownership</strong>`;
      }
      if (changes.contract_block.id === PublishesID) {
        return `Redistributed <strong>publishers</strong>`;
      } else {
        const block = R.find(R.propEq('id', changes.contract_block.id))(
          this.props.contractBlocks
        );
        if (block) {
          return `Proposed new <strong>${block.name}</strong> option`;
        }
      }
    } else if (changes && changes.sentence) {
      // return `Suggested changes to <strong>${changes.sentence.section}</strong>`;
      return `Suggested changes to <strong>${changes.sentence.section}</strong>`;
    }

    return '';
  }

  getTabName(dealChange) {
    const changes = JSON.parse(dealChange.changes);

    if (changes && changes.sentence) {
      return changes.sentence.section;
    }

    return '';
  }

  renderChanges() {
    const { dealChanges, members, profile } = this.props;
    const sortedDealChanges = _.orderBy(
      dealChanges,
      ['date_created'],
      ['desc']
    );

    return (
      dealChanges &&
      sortedDealChanges.map((dealChange, i) => {
        const member = getMemberByUserId(dealChange.user, members);
        const changeObj = JSON.parse(dealChange.changes);

        let changeContent = '';
        if (
          dealChange.type === 'agreement-text-sentence' ||
          dealChange.type === 'agreement-text-sentence-log'
        ) {
          changeContent = changeObj.sentence.content;
        }

        if (member && member.user_info) {
          const user = member.user_info;

          if (dealChange.type === 'update-contract-block') {
            return (
              <div key={i} className="change">
                <div className="user-photo">
                  <PhotoContainer
                    className="photo-container"
                    image={user.avatar}
                    defaultImg="user"
                  />
                </div>
                <span className="username">{user.name}</span>
                <div>
                  Updated:{' '}
                  {moment(dealChange.date_created).format(
                    'MM/DD/YYYY h:m:s A z'
                  )}
                  <br />
                  Summary:{' '}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: this.getSummary(dealChange),
                    }}
                  ></span>
                </div>
              </div>
            );
          } else if (
            dealChange.type === 'agreement-text-sentence' ||
            dealChange.type === 'agreement-text-sentence-log'
          ) {
            // Readlines/Changes that are made on the "Testing Version", only creator can see it
            let showLog = changeObj.isCurrentVersion;
            if (!showLog) {
              showLog = member.user_info.id === profile.id;
            }

            if (showLog) {
              return (
                <div key={i} className="change">
                  <div className="user-photo">
                    <PhotoContainer
                      className="photo-container"
                      image={user.avatar}
                      defaultImg="user"
                    />
                  </div>
                  <span className="username">{user.name}</span>
                  <div>
                    Updated:{' '}
                    {moment(dealChange.date_created).format(
                      'MM/DD/YYYY h:m:s A z'
                    )}
                    <br />
                    Summary:{' '}
                    <span>
                      {user.name} has submitted a redline to{' '}
                      <strong>{this.getTabName(dealChange)}</strong>
                    </span>
                    <div className="redline-summary">{changeContent}</div>
                  </div>
                </div>
              );
            }
          }
        }

        return null;
      })
    );
  }

  renderInvites() {
    const { invites, members } = this.props;
    const attorneys = R.filter((invite) => invite.type === 'other', invites);

    return attorneys.map((invite) => {
      const user = invite.invitee
        ? getMemberByUserId(invite.invitee, members)
        : null;
      return (
        <div key={invite.id} className="invite-user">
          <PhotoContainer
            className="photo-container"
            image={user ? user.avatar : null}
            defaultImg="user"
          />
          <h5>{user ? user.name : invite.name}</h5>
        </div>
      );
    });
  }

  render() {
    const { type } = this.props;
    const invites = type === 'review' ? this.renderInvites() : [];

    return (
      <div className="changes">
        {invites.length ? <h4>Invited To Review</h4> : null}
        {invites}
        <h4>Changelog</h4>
        {this.renderChanges()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  contractBlocks: state.global.contractBlocks,
  dealChanges: state.deals.dealChanges,
  invites: state.invites.invites,
  members: state.users.members,
  profile: state.profile,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DealChangeLog);



// WEBPACK FOOTER //
// src/components/Deals/ChangeLog.jsx